import { render, staticRenderFns } from "./manuscripts_edit.vue?vue&type=template&id=2148b382&scoped=true&"
import script from "./manuscripts_edit.vue?vue&type=script&lang=js&"
export * from "./manuscripts_edit.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./manuscripts_edit.vue?vue&type=style&index=1&id=2148b382&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2148b382",
  null
  
)

export default component.exports